var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Idle_03_Checkmark"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Idle_03_Checkmark",
    clipPath: "url(#clip-Icons_Idle_03_Checkmark)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000024688917951254936150000008386693706061424544_",
    transform: "translate(-11.4 2.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M186.106,413.939c125.917-75.045,263.379-200.6,379.916-292.243-18.4-19.122-37.523-54.48-55.923-73.241-3.247-3.247-6.855-6.855-11.545-6.855-3.969,0-7.937,2.526-11.185,5.051C393.2,119.171,302.282,227.409,198.012,285.136c-5.412,2.886-11.545,5.773-17.679,4.329-5.412-1.443-9.381-5.773-12.989-10.1-15.875-19.122-25.977-42.574-41.491-62.057-7.937-9.741-14.071-14.432-19.844-15.875-10.463-2.526-20.2,6.133-35.719,18.4C56.942,230.3,42.149,238.593,28.8,249.056c38.966,36.8,86.23,106.434,125.2,143.235,4.33,4.329,15.875,21.648,22.008,22.369",
    transform: "translate(45.378 73.805)",
    fill: "#79de75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M295.345,581.189C138.76,581.189,11.4,453.829,11.4,297.245S138.76,13.3,295.345,13.3A282.5,282.5,0,0,1,496.307,96.643a8.929,8.929,0,1,1-12.628,12.628A265.019,265.019,0,0,0,295.345,31.34C148.5,31.34,29.079,150.762,29.079,297.605S148.5,563.871,295.345,563.871,561.61,444.449,561.61,297.605a8.547,8.547,0,0,1,8.659-8.659,8.78,8.78,0,0,1,8.659,8.659c.722,156.224-127,283.584-283.584,283.584",
    transform: "translate(0 0)",
    fill: "#c1c1c1"
  })))));
};
export default __webpack_public_path__ + "static/media/Icons_Idle_03_Checkmark.b53f35cb.svg";
export { SvgComponent as ReactComponent };